import React from 'react'
import {
    AppState,
    NavEvent,
    BannerEvent,
    CollectionEvent,
    NavItem,
    DataLoaderGlobalParams,
} from '@news-mono/web-common'
import { useSelector } from 'react-redux'
import { StyledAd } from '../TheNightlyStickySiteHeader/TheNightlyStickySiteHeader.styled'
import { DimensionProps, withDimensions } from '../../__helpers/with-dimensions'

import {
    ProviderChildProps,
    TNHeaderNav,
    useTheNightlyHeaderNav,
} from '../../navigation'

export interface TheNightlyStickySiteHeaderProps {
    headerAd?: (rendered?: () => void) => JSX.Element | undefined
    onEvent: (event: NavEvent | CollectionEvent | BannerEvent) => void
    navigation: JSX.Element
    navItems: NavItem[]
    flyOutProps?: ProviderChildProps
    services: DataLoaderGlobalParams
}

type InternalProps = TheNightlyStickySiteHeaderProps & DimensionProps

export const InternalTheNightlyStickySiteHeader: React.FC<InternalProps> = ({
    headerAd,
    onEvent,
    navigation,
    navItems,
    flyOutProps,
    triggerMeasure,
    height,
    innerRef,
    services,
}) => {
    const renditionType = useSelector(
        (state: AppState) => state.render.renditionType,
    )

    const navState = useTheNightlyHeaderNav({
        onEvent,
        flyOutProps,
    })

    if (height !== navState.adHeight) {
        navState.updateAdHeight(height)
    }

    const disableHeaderAd = renditionType === 'app'

    return (
        <>
            <TNHeaderNav
                navState={navState}
                navigation={navigation}
                navItems={navItems}
                onEvent={onEvent}
                adComponent={!disableHeaderAd ? renderHeaderAd() : undefined}
                services={services}
            />
        </>
    )

    function renderHeaderAd() {
        return (
            headerAd && (
                <StyledAd className="headerAdvertisement" ref={innerRef}>
                    {headerAd(() => triggerMeasure())}
                </StyledAd>
            )
        )
    }
}

export const TheNightlyStickySiteHeader =
    withDimensions<TheNightlyStickySiteHeaderProps>(
        InternalTheNightlyStickySiteHeader,
    )

TheNightlyStickySiteHeader.displayName = 'TheNightlyStickySiteHeader'
